// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  background:
    radial-gradient(circle at top, rgba(247, 214, 178, 0.28), transparent 28%),
    linear-gradient(180deg, #f6efe6 0%, #f0e4d5 48%, #e6d7c4 100%);
  color: #263238;
  font-family: "Open Sans", sans-serif !important;
}

* {
  box-sizing: border-box;
}

.App {
  max-width: 1120px;
  margin: 0 auto;
  padding: 40px 24px 72px;
}

.App h1,
.App h2,
.App h3,
.App h4,
.App h5,
.App h6 {
  font-family: "Montserrat", sans-serif;
  color: #21313a;
  margin: 0 0 0.7em;
}

.App h1 {
  font-size: clamp(3rem, 7vw, 5.4rem);
  line-height: 0.92;
  letter-spacing: -0.05em;
  color: #1f3b4d;
  text-shadow: 0 10px 28px rgba(96, 73, 43, 0.12);
}

.App h2 {
  font-size: clamp(1.6rem, 3vw, 2.4rem);
  line-height: 1.12;
}

.App p {
  line-height: 1.7;
  color: #425863;
}

.App a {
  color: #8c4f2d;
  font-weight: 700;
  text-decoration: none;
}

.App a:hover {
  color: #a86137;
  text-decoration: underline;
}

.eyebrow {
  margin: 0 0 12px;
  color: #916148;
  font-size: 0.86rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.hero {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(280px, 0.9fr);
  gap: 28px;
  align-items: stretch;
}

.hero-copy,
.hero-panel,
.intro,
.proof-card,
.demo-card,
.audience-card,
.tab-content,
.conditional-input-panel,
.faq-section .accordion-item {
  border: 1px solid rgba(145, 97, 72, 0.12);
  border-radius: 24px;
  background: rgba(255, 250, 245, 0.82);
  box-shadow: 0 18px 60px rgba(96, 73, 43, 0.12);
  backdrop-filter: blur(10px);
}

.hero-copy {
  padding: 32px;
}

.brand-lockup {
  margin-bottom: 18px;
}

.brand-lockup-panel {
  display: flex;
  justify-content: center;
  margin-bottom: 22px;
}

.brand-logo-shell {
  display: flex;
  justify-content: center;
  align-items: center;
  width: min(100%, 190px);
  min-height: 210px;
  padding: 18px 18px 14px;
  border: 1px solid rgba(145, 97, 72, 0.14);
  border-radius: 30px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(247, 239, 230, 0.92) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.65),
    0 18px 30px rgba(96, 73, 43, 0.12);
}

.brand-logo {
  display: block;
  width: min(280px, 62%);
  max-width: 100%;
  height: auto;
  filter: drop-shadow(0 8px 22px rgba(88, 60, 39, 0.14));
}

.brand-logo-panel {
  width: min(168px, 100%);
  filter: drop-shadow(0 8px 16px rgba(31, 59, 77, 0.12));
}

.hero-copy h2 {
  max-width: 14ch;
}

.hero-text {
  max-width: 62ch;
  font-size: 1.05rem;
  color: #4b606b;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 28px;
}

.hero-panel {
  padding: 28px;
  display: flex;
  flex-direction: column;
}

.hero-panel h3 {
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 18px;
}

.value-list {
  margin: 0;
  padding-left: 20px;
  color: #4b606b;
}

.value-list li {
  margin-bottom: 14px;
}

.hero-note {
  margin: 18px 0 0;
  color: #6b7f88;
  font-size: 0.95rem;
}

.proof-grid,
.demo-grid,
.audience-grid {
  display: grid;
  gap: 18px;
}

.proof-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 24px 0 40px;
}

.proof-card,
.demo-card,
.audience-card {
  padding: 22px;
  text-align: left;
}

.proof-card h3,
.demo-card h3,
.audience-card h3 {
  margin-bottom: 10px;
  font-size: 1.15rem;
}

.section-heading {
  max-width: 760px;
  margin: 0 0 20px;
}

.demo-section,
.audience-section {
  margin: 0 0 42px;
}

.demo-grid,
.audience-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.demo-card p,
.audience-card p,
.proof-card p {
  margin: 0;
  color: #4b606b;
}

.intro {
  padding: 24px 28px;
  margin-bottom: 28px;
  text-align: left;
}

.intro h2 {
  font-size: 1.55rem;
}

.App form {
  padding: 0;
  margin-bottom: 30px;
}

.App label {
  display: block;
  margin-bottom: 0.5em;
  color: #31444e;
  text-align: left;
}

.App input[type="file"],
.App input[type="text"],
.App input[type="number"] {
  width: 100%;
  margin-bottom: 15px;
  padding: 0.9em 1em;
  border: 1px solid rgba(110, 130, 141, 0.22);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.95);
  color: #263238;
}

.App input::placeholder {
  color: #7e9099;
}

.App button,
.secondary-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 12px 22px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(135deg, #7eb7a9 0%, #5f9d91 100%);
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  text-decoration: none;
  box-shadow: 0 10px 24px rgba(95, 157, 145, 0.24);
}

.App button:hover,
.secondary-link:hover {
  transform: translateY(-1px);
  color: #ffffff;
  text-decoration: none;
}

.secondary-link {
  background: transparent;
  border: 1px solid rgba(95, 157, 145, 0.45);
  color: #35665d;
  box-shadow: none;
}

.secondary-link:hover {
  color: #234942;
  border-color: rgba(95, 157, 145, 0.82);
}

.App button:disabled {
  background: #5e707b;
  color: #eef3f6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.App .error {
  margin-top: 15px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(196, 92, 81, 0.14);
  color: #8f4038;
}

.App .tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
  justify-content: center;
}

.App .tabs button {
  min-height: 42px;
  padding: 10px 18px;
  border: 1px solid rgba(110, 130, 141, 0.18);
  background: rgba(255, 250, 245, 0.92);
  color: #425863;
  box-shadow: none;
}

.App .tabs button:hover {
  color: #ffffff;
}

.App .tabs button.active {
  background: linear-gradient(135deg, #7eb7a9 0%, #5f9d91 100%);
  color: #ffffff;
  border-color: transparent;
}

.App .tab-content {
  margin-top: 24px;
  padding: 26px;
  text-align: left;
}

.App .tab-content h1,
.App .tab-content h2,
.App .tab-content h3,
.App .tab-content h4,
.App .tab-content h5,
.App .tab-content h6 {
  color: #21313a;
}

.App .tab-content p {
  margin-bottom: 1.1em;
  color: #425863;
}

.App .conditional-input-panel {
  margin-top: 15px;
  padding: 20px;
  text-align: left;
}

.tooltip {
  position: relative;
  display: inline-block;
  margin-left: 6px;
  cursor: help;
}

.tooltip::before {
  content: attr(title);
  position: absolute;
  bottom: 115%;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 10px;
  border-radius: 10px;
  background: #122330;
  color: #eef3f6;
  font-size: 0.78em;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;
  z-index: 1;
}

.tooltip:hover::before {
  opacity: 1;
  visibility: visible;
}

.App .form-inline {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
}

.App .form-inline label {
  width: 80%;
  margin: 0;
}

.App .form-inline input[type="number"],
.App .form-inline input[type="checkbox"] {
  flex-grow: 1;
  min-width: 0;
}

.record-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}

.recording-status {
  color: #a86137;
  font-weight: 700;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  margin-top: 26px;
}

.donate-section {
  text-align: left;
}

.donate-section p {
  margin: 0 0 10px;
  color: #5b6f79;
}

.faq-section {
  margin-top: 42px;
}

.faq-section .accordion-item {
  overflow: hidden;
}

.faq-section .accordion-button,
.faq-section .accordion-button:not(.collapsed),
.faq-section .accordion-button:focus {
  background: rgba(255, 250, 245, 0.92);
  color: #21313a;
  box-shadow: none;
}

.faq-section .accordion-button:not(.collapsed) {
  color: #8c4f2d;
}

.faq-section .accordion-button::after {
  filter: sepia(0.3) saturate(0.8);
}

.faq-section .accordion-body {
  background: rgba(255, 250, 245, 0.92);
  color: #425863;
}

.accordion-header {
  margin-bottom: 0 !important;
}

@media (max-width: 880px) {
  .hero,
  .proof-grid,
  .demo-grid,
  .audience-grid {
    grid-template-columns: 1fr;
  }

  .App {
    padding: 28px 16px 56px;
  }

  .hero-copy,
  .hero-panel,
  .intro,
  .proof-card,
  .demo-card,
  .audience-card,
  .tab-content {
    padding: 22px;
  }

  .App .form-inline {
    flex-direction: column;
    align-items: stretch;
  }

  .App .form-inline label {
    width: 100%;
  }

  .button-container {
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;kEAEgE;EAChE,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;;;;;EAME,qCAAqC;EACrC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,SAAS;EACT,oBAAoB;AACtB;;AAEA;;;;;;;;;EASE,yCAAyC;EACzC,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;EACnB,iGAAiG;EACjG;;sCAEoC;AACtC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;;EAGE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2EAA2E;EAC3E,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;;;;;IAOE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["body {\n  margin: 0;\n  background:\n    radial-gradient(circle at top, rgba(247, 214, 178, 0.28), transparent 28%),\n    linear-gradient(180deg, #f6efe6 0%, #f0e4d5 48%, #e6d7c4 100%);\n  color: #263238;\n  font-family: \"Open Sans\", sans-serif !important;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.App {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 40px 24px 72px;\n}\n\n.App h1,\n.App h2,\n.App h3,\n.App h4,\n.App h5,\n.App h6 {\n  font-family: \"Montserrat\", sans-serif;\n  color: #21313a;\n  margin: 0 0 0.7em;\n}\n\n.App h1 {\n  font-size: clamp(3rem, 7vw, 5.4rem);\n  line-height: 0.92;\n  letter-spacing: -0.05em;\n  color: #1f3b4d;\n  text-shadow: 0 10px 28px rgba(96, 73, 43, 0.12);\n}\n\n.App h2 {\n  font-size: clamp(1.6rem, 3vw, 2.4rem);\n  line-height: 1.12;\n}\n\n.App p {\n  line-height: 1.7;\n  color: #425863;\n}\n\n.App a {\n  color: #8c4f2d;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.App a:hover {\n  color: #a86137;\n  text-decoration: underline;\n}\n\n.eyebrow {\n  margin: 0 0 12px;\n  color: #916148;\n  font-size: 0.86rem;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n}\n\n.hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) minmax(280px, 0.9fr);\n  gap: 28px;\n  align-items: stretch;\n}\n\n.hero-copy,\n.hero-panel,\n.intro,\n.proof-card,\n.demo-card,\n.audience-card,\n.tab-content,\n.conditional-input-panel,\n.faq-section .accordion-item {\n  border: 1px solid rgba(145, 97, 72, 0.12);\n  border-radius: 24px;\n  background: rgba(255, 250, 245, 0.82);\n  box-shadow: 0 18px 60px rgba(96, 73, 43, 0.12);\n  backdrop-filter: blur(10px);\n}\n\n.hero-copy {\n  padding: 32px;\n}\n\n.brand-lockup {\n  margin-bottom: 18px;\n}\n\n.brand-lockup-panel {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 22px;\n}\n\n.brand-logo-shell {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: min(100%, 190px);\n  min-height: 210px;\n  padding: 18px 18px 14px;\n  border: 1px solid rgba(145, 97, 72, 0.14);\n  border-radius: 30px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(247, 239, 230, 0.92) 100%);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.65),\n    0 18px 30px rgba(96, 73, 43, 0.12);\n}\n\n.brand-logo {\n  display: block;\n  width: min(280px, 62%);\n  max-width: 100%;\n  height: auto;\n  filter: drop-shadow(0 8px 22px rgba(88, 60, 39, 0.14));\n}\n\n.brand-logo-panel {\n  width: min(168px, 100%);\n  filter: drop-shadow(0 8px 16px rgba(31, 59, 77, 0.12));\n}\n\n.hero-copy h2 {\n  max-width: 14ch;\n}\n\n.hero-text {\n  max-width: 62ch;\n  font-size: 1.05rem;\n  color: #4b606b;\n}\n\n.hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 28px;\n}\n\n.hero-panel {\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n}\n\n.hero-panel h3 {\n  font-size: 1.1rem;\n  text-align: center;\n  margin-bottom: 18px;\n}\n\n.value-list {\n  margin: 0;\n  padding-left: 20px;\n  color: #4b606b;\n}\n\n.value-list li {\n  margin-bottom: 14px;\n}\n\n.hero-note {\n  margin: 18px 0 0;\n  color: #6b7f88;\n  font-size: 0.95rem;\n}\n\n.proof-grid,\n.demo-grid,\n.audience-grid {\n  display: grid;\n  gap: 18px;\n}\n\n.proof-grid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin: 24px 0 40px;\n}\n\n.proof-card,\n.demo-card,\n.audience-card {\n  padding: 22px;\n  text-align: left;\n}\n\n.proof-card h3,\n.demo-card h3,\n.audience-card h3 {\n  margin-bottom: 10px;\n  font-size: 1.15rem;\n}\n\n.section-heading {\n  max-width: 760px;\n  margin: 0 0 20px;\n}\n\n.demo-section,\n.audience-section {\n  margin: 0 0 42px;\n}\n\n.demo-grid,\n.audience-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.demo-card p,\n.audience-card p,\n.proof-card p {\n  margin: 0;\n  color: #4b606b;\n}\n\n.intro {\n  padding: 24px 28px;\n  margin-bottom: 28px;\n  text-align: left;\n}\n\n.intro h2 {\n  font-size: 1.55rem;\n}\n\n.App form {\n  padding: 0;\n  margin-bottom: 30px;\n}\n\n.App label {\n  display: block;\n  margin-bottom: 0.5em;\n  color: #31444e;\n  text-align: left;\n}\n\n.App input[type=\"file\"],\n.App input[type=\"text\"],\n.App input[type=\"number\"] {\n  width: 100%;\n  margin-bottom: 15px;\n  padding: 0.9em 1em;\n  border: 1px solid rgba(110, 130, 141, 0.22);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.95);\n  color: #263238;\n}\n\n.App input::placeholder {\n  color: #7e9099;\n}\n\n.App button,\n.secondary-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 12px 22px;\n  border: none;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #7eb7a9 0%, #5f9d91 100%);\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 700;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n  text-decoration: none;\n  box-shadow: 0 10px 24px rgba(95, 157, 145, 0.24);\n}\n\n.App button:hover,\n.secondary-link:hover {\n  transform: translateY(-1px);\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.secondary-link {\n  background: transparent;\n  border: 1px solid rgba(95, 157, 145, 0.45);\n  color: #35665d;\n  box-shadow: none;\n}\n\n.secondary-link:hover {\n  color: #234942;\n  border-color: rgba(95, 157, 145, 0.82);\n}\n\n.App button:disabled {\n  background: #5e707b;\n  color: #eef3f6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.App .error {\n  margin-top: 15px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: rgba(196, 92, 81, 0.14);\n  color: #8f4038;\n}\n\n.App .tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 30px;\n  justify-content: center;\n}\n\n.App .tabs button {\n  min-height: 42px;\n  padding: 10px 18px;\n  border: 1px solid rgba(110, 130, 141, 0.18);\n  background: rgba(255, 250, 245, 0.92);\n  color: #425863;\n  box-shadow: none;\n}\n\n.App .tabs button:hover {\n  color: #ffffff;\n}\n\n.App .tabs button.active {\n  background: linear-gradient(135deg, #7eb7a9 0%, #5f9d91 100%);\n  color: #ffffff;\n  border-color: transparent;\n}\n\n.App .tab-content {\n  margin-top: 24px;\n  padding: 26px;\n  text-align: left;\n}\n\n.App .tab-content h1,\n.App .tab-content h2,\n.App .tab-content h3,\n.App .tab-content h4,\n.App .tab-content h5,\n.App .tab-content h6 {\n  color: #21313a;\n}\n\n.App .tab-content p {\n  margin-bottom: 1.1em;\n  color: #425863;\n}\n\n.App .conditional-input-panel {\n  margin-top: 15px;\n  padding: 20px;\n  text-align: left;\n}\n\n.tooltip {\n  position: relative;\n  display: inline-block;\n  margin-left: 6px;\n  cursor: help;\n}\n\n.tooltip::before {\n  content: attr(title);\n  position: absolute;\n  bottom: 115%;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: #122330;\n  color: #eef3f6;\n  font-size: 0.78em;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s, visibility 0.2s;\n  z-index: 1;\n}\n\n.tooltip:hover::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n.App .form-inline {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.App .form-inline label {\n  width: 80%;\n  margin: 0;\n}\n\n.App .form-inline input[type=\"number\"],\n.App .form-inline input[type=\"checkbox\"] {\n  flex-grow: 1;\n  min-width: 0;\n}\n\n.record-controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.recording-status {\n  color: #a86137;\n  font-weight: 700;\n}\n\n.button-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 26px;\n}\n\n.donate-section {\n  text-align: left;\n}\n\n.donate-section p {\n  margin: 0 0 10px;\n  color: #5b6f79;\n}\n\n.faq-section {\n  margin-top: 42px;\n}\n\n.faq-section .accordion-item {\n  overflow: hidden;\n}\n\n.faq-section .accordion-button,\n.faq-section .accordion-button:not(.collapsed),\n.faq-section .accordion-button:focus {\n  background: rgba(255, 250, 245, 0.92);\n  color: #21313a;\n  box-shadow: none;\n}\n\n.faq-section .accordion-button:not(.collapsed) {\n  color: #8c4f2d;\n}\n\n.faq-section .accordion-button::after {\n  filter: sepia(0.3) saturate(0.8);\n}\n\n.faq-section .accordion-body {\n  background: rgba(255, 250, 245, 0.92);\n  color: #425863;\n}\n\n.accordion-header {\n  margin-bottom: 0 !important;\n}\n\n@media (max-width: 880px) {\n  .hero,\n  .proof-grid,\n  .demo-grid,\n  .audience-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .App {\n    padding: 28px 16px 56px;\n  }\n\n  .hero-copy,\n  .hero-panel,\n  .intro,\n  .proof-card,\n  .demo-card,\n  .audience-card,\n  .tab-content {\n    padding: 22px;\n  }\n\n  .App .form-inline {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .App .form-inline label {\n    width: 100%;\n  }\n\n  .button-container {\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
